// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import 'react-image-crop/dist/ReactCrop.css';
import 'formiojs/dist/formio.full.min.css';

if (process.env.NODE_ENV === 'development') {
  const hideCraErrorOverlay = () => {
    const nodes = Array.from(document.querySelectorAll('iframe, div'));

    nodes.forEach((node) => {
      const id = (node.id || '').toLowerCase();
      const className = typeof node.className === 'string' ? node.className.toLowerCase() : '';
      const title = (node.getAttribute?.('title') || '').toLowerCase();

      const looksLikeOverlay =
        id.includes('react-error-overlay') ||
        className.includes('react-error-overlay') ||
        title.includes('error overlay') ||
        title.includes('webpack') ||
        (node.tagName === 'IFRAME' && window.getComputedStyle(node).position === 'fixed');

      if (looksLikeOverlay) {
        node.style.display = 'none';
      }
    });
  };

  const observer = new MutationObserver(() => {
    hideCraErrorOverlay();
  });

  const startObserver = () => {
    if (!document.body) return;

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    hideCraErrorOverlay();
  };

  window.addEventListener('load', hideCraErrorOverlay);
  window.addEventListener('error', () => {
    setTimeout(hideCraErrorOverlay, 0);
  });
  window.addEventListener('unhandledrejection', () => {
    setTimeout(hideCraErrorOverlay, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
